<template>
    <div class="course_list_content use_common" :class="{course_content_hidden: isFixedHeight, course_content_bottom: !isBeginActivity, course_list_content_top: navNumberList.length > 0, course_content_bottom_iphoneX: isIphoneX}">
        <!--活动未开始-->
        <div v-if="!isEndActivity" v-cloak>
            <div class="title_content flex_box" :class="{title_content_left: (navNumberShowString.length <= 1 && !selectNavString) || (navNumberList.indexOf(3) === -1 && navNumberList.length===1) }" v-if="navNumberList.length > 0">
                <div class="title_name_content flex_box" @click="selectSchoolType(1)" v-if="navNumberList.indexOf(0) > -1">
                    <span class="title_name tow" :class="{title_name_color: filterNum === 1}">{{schoolName || '校区'}}</span>
                    <img class="down_arrow_icon" v-if="filterNum === 1 && isShowPopupList" src="../../assets/uparrow.png" alt="">
                    <img class="down_arrow_icon" src="../../assets/downarrowicon.png" alt="" v-else>
                </div>
                <div class="title_name_content flex_box" @click="selectSchoolType(2)" v-if="navNumberList.indexOf(1) > -1">
                    <span class="title_name tow" :class="{title_name_color: filterNum === 2}">{{gradeName || '年级'}}</span>
                    <img class="down_arrow_icon" v-if="filterNum === 2 && isShowPopupList" src="../../assets/uparrow.png" alt="">
                    <img class="down_arrow_icon" src="../../assets/downarrowicon.png" alt="" v-else>
                </div>
                <div class="title_name_content flex_box" @click="selectSchoolType(4)" v-if="navNumberList.indexOf(2) > -1">
                    <span class="title_name tow" :class="{title_name_color: filterNum === 4}">{{subjectName || '科目'}}</span>
                    <img class="down_arrow_icon" v-if="filterNum === 4 && isShowPopupList" src="../../assets/uparrow.png" alt="">
                    <img class="down_arrow_icon" src="../../assets/downarrowicon.png" alt="" v-else>
                </div>
                <div class="title_name_content flex_box" @click="selectSchoolType(3)" v-if="navNumberList.indexOf(3) > -1 && selectNavString == navNumberShowString">
                    <span class="title_name tow" :class="{title_name_color: filterNum === 3}">{{timeName || '时间'}}</span>
                    <img class="down_arrow_icon" v-if="filterNum === 3 && isShowPopupList" src="../../assets/uparrow.png" alt="">
                    <img class="down_arrow_icon" src="../../assets/downarrowicon.png" alt="" v-else>
                </div>
            </div>
            <!--课程列表-->
            <v-reload
                    :on-infinite-load="onInfiniteLoad"
                    :parent-pull-up-state="pullUpState"
                    :footer-content="isShowPullUpFooter"
            >
                <div class="course_package_list course_package_list_top" v-cloak v-if="courseList.length">
                    <div class="package_content">
                        <div class="package_title flex_box">
                            <div class="package_title_text tow">选课</div>
                        </div>
                        <div class="course_list_details" v-for="(courseItem, courseIndex) in courseList" :key="courseIndex" :class="{course_list_details_opacity: courseItem.registrationState===6}" @click="selectCourse(courseItem)">
                            <div class="course_name_content">
                                <span class="class_type" v-if="courseItem.seasonName">{{courseItem.seasonName}}</span>
                                <span class="teaching_methods" v-if="courseItem.teachingMethod&&teachingMethod(courseItem.teachingMethod)">{{teachingMethod(courseItem.teachingMethod || '')}}</span>
                                <span class="course_name">{{courseItem.className}}</span>
                            </div>
                            <div class="flex_box class_num_time">
                                <span class="lessons_num">{{courseItem.classCode}}</span>
                                <span class="lessons_num">{{getClassLessonTimes(courseItem.lessonTimes, (courseItem.realMinutes || 0))}}</span>
                                <span class="lessons_num" v-if="getClassStay(courseItem.classMode || '')">住宿班</span>
                                <span class="course_quota" v-if="courseItem.registrationState===1&&isFew((courseItem.maxNum - courseItem.usableCount), courseItem.maxNum, courseItem.registrationState)">名额紧张</span>
                                <span class="course_quota" v-if="courseItem.registrationState===2||courseItem.registrationState===3">已开课/可插班</span>
                                <span class="course_quota open_course_status" v-if="courseItem.registrationState===4">已开课</span>
                                <span class="course_quota open_course_status" v-if="courseItem.registrationState===6">已报满</span>
                            </div>
                            <div class="flex_box course_details">
                                <img class="learn_place_icon" src="../../assets/cardaddricon.png" />
                                <span class="class_num tow">{{courseItem.learnPlace}}</span>
                            </div>
                            <div class="flex_box course_details">
                                <img class="card_year_icon" src="../../assets/cardyearicon.png" />
                                <span class="class_num">{{formatDate(new Date(courseItem.startDate.replace(/-/g, '/') + '+0800'), 'yyyy/MM/dd')+'至'+formatDate(new Date(courseItem.endDate.replace(/-/g, '/') + '+0800'), 'yyyy/MM/dd')}}</span>
                            </div>
                            <div class="course_details course_time_details">
                                <img class="card_time_icon" src="../../assets/cardtimeicon.png" />
                                <div class="flex_box">
                                    <span class="time_details text_ellipsis_two">{{courseItem.learnTime}}</span>
                                </div>
                            </div>

                            <div class="first_shift_time" v-if="courseItem.registrationState===2||courseItem.registrationState===3">插班首次课时间：{{courseItem.insertLessonTimeText}}</div>
                            <div class="course_dot_line" v-else></div>

                            <div class="flex_box lesson_and_price_content">
                                <div class="flex_box" v-if="courseItem.teacherList && courseItem.teacherList.length >= 1">
                                    <div class="flex_box more_teacher_content"  v-for="(teacherinfo, index) in courseItem.teacherList.slice(0,2)" :key="index">
                                        <img class="teacher_icon" v-if="teacherinfo.newLogoUrl" :src="teacherinfo.newLogoUrl" onerror="javascript:this.src='https://cdn.xdf.cn/souke/h5-pages/components/teacher-info-card/images/default_teacher_photo.svg'"/>
                                        <img class="teacher_icon"  src="../../assets/cardteachericon.png" v-else/>
                                        <span class="teacher_name">{{teacherinfo.teacherName}}</span>
                                    </div>
                                    <div class="teacher_name" v-if="courseItem.teacherList && courseItem.teacherList.length > 2">...</div>
                                </div>
                                <div class="flex_box more_teacher_content" v-else>
                                    <img class="teacher_icon" src="../../assets/cardteachericon.png" />
                                    <span class="teacher_name">待定</span>
                                </div>

                                <div class="price_symbol_content">
                                    <span class="price_symbol">¥</span>
                                    <span class="course_price">{{courseItem.price}}</span>
                                </div>
                            </div>
                            <div class="select_icon">
                                <img v-if="courseItem.isSelect&&courseItem.registrationState!==6" src="../../assets/selectcourse.png" alt="">
                                <img v-else-if="courseItem.registrationState===6" src="../../assets/nocourse.png" alt="">
                                <img v-else src="../../assets/unselectcourse.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </v-reload>

            <!--底部按钮-->
            <div class="activity_time" v-if="!isBeginActivity" :class="{activity_time_bottom: isIphoneX}">
                活动将于{{beginTimeText}}开始
            </div>
            <div class="footer_content flex_box" :class="{footer_content_bottom: isIphoneX}">
                <a class="call_phone flex_box_column" :href="!isIosApp ? 'tel:' + phone : 'javascript:;'" @click="callPhone">
                    <img class="call_phone_icon" src="../../assets/callphoneicon.png" alt="">
                    <span class="call_phone_text">咨询</span>
                </a>
                <div class="buy_course" @click="payMoney">{{ singleCartList.length ? '立即抢购(' + singleCartList.length + ')' : '请选择课程'}}</div>
            </div>
        </div>

        <!--活动已结束-->
        <div v-if="isEndActivity">
            <end-activity></end-activity>
        </div>
        <!--弹窗-->
        <div class="filter_item_content_bg" v-if="isShowPopupList" @click="closePopupList">
            <div class="filter_item_content">
                <div class="filter_item" v-for="(item, index) in filterTypeList" :key="index" @click="selectFilterItem(item, index)">
                    <div class="filter_item_line" v-if="selectTypeId !== '' && Number(selectTypeId) === index"></div>
                    <div class="filter_item_line_name tow" :class="{filter_item_line_name_color: selectTypeId !== '' && Number(selectTypeId) === index}">{{item}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import wxSdk from '../../libs/wxsdk.js'
    import PullUpReload from '../../components/pullUpReload'
    import EndActivity from '../../components/endActivity'
    import {getNewMarketInfo, getNewMarketClassList, recordChannel, checkWxLogin, getGan} from '../../libs/api'
    import {
        formatDateUtil,
        teachingMethodUtil,
        getClassLessonTimesUtil,
        getClassStayUtil,
        isFewUtil,
        getIphoneXType,
        isWeChat
    } from "../../libs/util"
    import configData from '../../libs/conf'
    import { Indicator, Toast } from 'mint-ui'
    import Cookies from 'js-cookie'
    import $ from 'jquery'
    export default {
        name:'singlelist',
        metaInfo () {
            return {
                title: this.pageName
            }
        },
        components: {
            'v-reload': PullUpReload,
            'end-activity': EndActivity
        },
        data () {
            return {
                phone: '',
                pageName: '新东方专题活动',
                isFixedHeight: false, // 是否固定页面高度
                isShowPopupList:false, // 是否显示弹窗列表
                subjectList: [], // 科目列表
                navList: [], // 导航栏
                filterTypeList: [], // 筛选列表
                selectTypeId: '', // 选中筛选类型的Id
                filterNum: '', // 1: 学校 2: 年级  3: 时间
                schoolName: '', // 校区名字
                gradeName: '', // 年级名字
                subjectName: '', // 科目名字
                timeName: '', // 时间名字
                selectSchoolId: '', // 选中的学校Id
                selectGradeId: '', // 选中的校区Id
                selectSubjectId: '', // 选中的科目Id
                selectTimeId: '', // 选中的时间Id
                navNumberList:[], // 导航栏的存在的数字
                navNumberShowString: '', // 导航栏的存在先显示的数字
                selectNavString: '', // 选择学校0，时间1，科目2，显示时间栏
                activityInfo: '', // 活动信息
                beginTimeText: '', // 活动开始时间文本
                isBeginActivity: true, // 是否开始活动
                isEndActivity: false, // 是否结束活动
                courseList:[], // 课程列表
                activityId: '', // 活动Id
                pageNumber: 1, // 当前页数
                pageSize: 20, // 一页多少个
                total: '',  // 总量
                pullUpState: 1, // 子组件的pullUpState状态
                singleCartList: [], // 购物车
                isShowPullUpFooter: true, // 是否显示加载更多底部
                U2AT:'', // token
                schoolId: '', // 学校Id
                // 以下是信息缓存部分
                campusSet: [], // 校区纬度
                gradeSet: [], // 年级纬度
                subjectSet: [], // 科目纬度
                classTimeSet: [], // 时间纬度
                dimensionList: [], // 所有纬度list
                courseClassList: [], // 课程列表
                tempCourseClassList: [], // 临时存储的课程列表
                classCodeList: [], // 过滤的课程
                isIosApp: false, // 是否是iosApp
                isIphoneX: false, // 是否iphoneX
                isWeChat: false, //  是否在微信环境内
                wxNickName: '', // 打点微信数据
                agentName: '', // 邮箱或者手机号
                agn: '' // 推广渠道
            }
        },
        mounted () {
            // 专题详情
            Indicator.open({
                text: '加载中...',
                spinnerType: 'fading-circle'
            })
            let queryParams = this.$route.query
            // 获取标题参数
            let courserTitle = JSON.parse(sessionStorage.getItem('courserTitle'))
            if (!courserTitle) {
                courserTitle = queryParams
            }

            if (courserTitle) {
                this.schoolName = courserTitle.schoolName || ''
                this.selectSchoolId = courserTitle.selectSchoolId || ''
                this.gradeName = courserTitle.gradeName || ''
                this.selectGradeId  = courserTitle.selectGradeId || ''
                this.subjectName = courserTitle.subjectName || ''
                this.selectSubjectId = courserTitle.selectSubjectId || ''
                this.timeName  = courserTitle.timeName || ''
                this.selectTimeId  = courserTitle.selectTimeId || ''
                this.filterNum = Number(courserTitle.filterNum) || ''
                this.activityId = courserTitle.activityId || ''
                this.channelId = courserTitle.channelId || ''
                this.agn = courserTitle.agn || ''
                this.selectNavString = courserTitle.selectNavString || ''
                if (courserTitle.selectSchoolId === 0) {
                    this.selectSchoolId = 0
                }
                if (courserTitle.selectGradeId === 0) {
                    this.selectGradeId = 0
                }
                if (courserTitle.selectSubjectId === 0) {
                    this.selectSubjectId = 0
                }
                if (courserTitle.selectTimeId === 0) {
                    this.selectTimeId = 0
                }
                this.saveTitleInfo()
                switch(Number(this.filterNum)) {
                    case 1: // 校区名字
                        this.selectTypeId = this.selectSchoolId
                        break
                    case 2: // 年级名字
                        this.selectTypeId = this.selectGradeId
                        break
                    case 3: // 时间名字
                        this.selectTypeId = this.selectTimeId
                        break
                    case 4: // 科目名字
                        this.selectTypeId = this.selectSubjectId
                        break
                }
            }

            // 判断是否在微信环境内,是否授权
            this.isWeChat = isWeChat()
            this.checkWxLogin()

            // 获取购物车数量
            this.singleCartList = JSON.parse(sessionStorage.getItem('singleCartList')) || []
            // 获取纬度及课程列表
            this.getMarketInfo()
            this.getMarketClassList()
            this.getGan()

            // 大屏幕手机适配
            if ((window.screen.width === 375 && window.screen.height > 667) || (window.screen.width === 414 && window.screen.height > 667)) {
                $(".course_content_hidden").css("max-height", "1624")
            }
            // 打点数据
            gio('page.set',{
                'activity_id': this.activityId,
                'channel_id': this.channelId
            })

            // 是否在app内并且是否是ios
            if (xdfJs.xdfhybird.inApp && !xdfJs.xdfhybird.android) {
                this.isIosApp = true
            }

            // 判断是否IphoneX
            this.isIphoneX = getIphoneXType()
        },
        methods: {
            // 选择筛选选项
            selectSchoolType(num) {
                this.filterNum = num
                this.selectTypeId = ''
                this.isFixedHeight = true
                this.isShowPopupList = true
                switch(num) {
                    case 1: // 校区名字
                        this.selectTypeId = this.selectSchoolId
                        this.getDimensionList(1, 1)
                        break
                    case 2: // 年级名字
                        this.selectTypeId = this.selectGradeId
                        this.getDimensionList(2, 1)
                        break
                    case 3: // 时间名字
                        this.selectTypeId = this.selectTimeId
                        this.getDimensionList(3, 1)
                        break
                    case 4: // 科目名字
                        this.selectTypeId = this.selectSubjectId
                        this.getDimensionList(4, 1)
                        break
                }
            },
            // 选择筛选列表
            selectFilterItem(itemName, itemIndex) {
                this.isFixedHeight = false
                this.isShowPopupList = false
                this.selectTypeId = itemIndex
                switch(this.filterNum) {
                    case 1: // 校区名字
                        this.selectSchoolId = itemIndex
                        this.schoolName = itemName
                        this.selectNavString = ''
                        if (this.selectNavString.indexOf('0') == -1) {
                            this.selectNavString += '0'
                        }
                        // 重新选择清空数据
                        this.selectGradeId = ''
                        this.gradeName = ''
                        this.selectSubjectId = ''
                        this.subjectName = ''
                        this.selectTimeId = ''
                        this.timeName = ''
                        // 缓存信息
                        this.gradeSet = []
                        this.subjectSet = []
                        this.classTimeSet = []
                        break
                    case 2: // 年级名字
                        this.selectGradeId = itemIndex
                        this.gradeName = itemName
                        if (this.selectNavString.indexOf('0') > -1) {
                            this.selectNavString = '0'
                        } else {
                            this.selectNavString = ''
                        }
                        if (this.selectNavString.indexOf('1') == -1) {
                            this.selectNavString += '1'
                        }
                        // 重新选择清空数据
                        this.selectSubjectId = ''
                        this.subjectName = ''
                        this.selectTimeId = ''
                        this.timeName = ''
                        // 缓存信息
                        this.subjectSet = []
                        this.classTimeSet = []
                        break
                    case 3: // 时间名字
                        this.selectTimeId = itemIndex
                        this.timeName = itemName
                        break
                    case 4: // 科目名字
                        this.selectSubjectId = itemIndex
                        this.subjectName = itemName
                        if (this.selectNavString.indexOf('2') == -1) {
                            this.selectNavString += '2'
                        }
                        // 重新选择清空数据
                        this.selectTimeId = ''
                        this.timeName = ''
                        this.classTimeSet = []
                        break
                }
                this.saveTitleInfo()
                this.courseList = []
                this.getDimensionList()
                this.getWxSdk()
            },
            // 存储标题参数
            saveTitleInfo () {
                // 存储学校名字
                let courserTitleInfo = {
                    schoolName: this.schoolName,
                    selectSchoolId: this.selectSchoolId,
                    gradeName: this.gradeName,
                    selectGradeId: this.selectGradeId,
                    subjectName: this.subjectName,
                    selectSubjectId: this.selectSubjectId,
                    timeName: this.timeName,
                    selectTimeId: this.selectTimeId,
                    filterNum: this.filterNum,
                    activityId: this.activityId,
                    channelId: this.channelId,
                    selectNavString: this.selectNavString,
                    agn: this.agn
                }
                sessionStorage.setItem('courserTitle', JSON.stringify(courserTitleInfo))
            },
            // 关闭弹窗
            closePopupList() {
                this.isFixedHeight = false
                this.isShowPopupList = false
            },
            // 获取专题详情
            getMarketInfo(){
                getNewMarketInfo(this.activityId).then((res) => {
                    let resData = res
                    if (resData.code == 1) {
                        let data = resData.data
                        this.activityInfo = data.activityinfo
                        let nowTime = new Date(this.activityInfo.nowTime.replace(/-/g, '/') + '+0800').valueOf()
                        let beginTime = new Date(this.activityInfo.beginTime.replace(/-/g, '/') + '+0800').valueOf()
                        let beginTimeText = formatDateUtil(new Date(this.activityInfo.beginTime.replace(/-/g, '/') + '+0800'), 'MM月dd日 HH:mm')
                        let endTime = new Date(this.activityInfo.endTime.replace(/-/g, '/') + '+0800').valueOf()
                        this.beginTimeText = beginTimeText
                        this.phone = this.activityInfo.connectPhone
                        this.schoolId = this.activityInfo.schoolId
                        this.pageName = this.activityInfo.title
                        // 活动未开始
                        if (nowTime < beginTime) {
                            this.isBeginActivity = false
                        }
                        // 活动已结束
                        if (nowTime > endTime) {
                            this.isEndActivity = true
                        }

                        // 标题列表
                        this.navList = data.navList
                        this.navList.forEach((navItem) => {
                            this.navNumberList.push(navItem.type)
                            if (navItem.type < 3) {
                                this.navNumberShowString += navItem.type
                            }
                        })
                        // 微信分享
                        this.getWxSdk()
                        // 缓存信息内容 只有没有选择纬度的情况下再去赋值
                        this.campusSet = data.campusSet
                        if (!this.schoolName && !this.gradeName && !this.subjectName && !this.timeName) {
                            this.gradeSet = data.gradeSet
                            this.subjectSet = data.subjectSet
                            this.classTimeSet = data.classTimeSet
                        }
                    }

                })
            },
            // 根据选择的纬度参数显示每一纬度的内容
            getDimensionList(num, numType) {
                let filterNum
                if (num) {
                    filterNum = num
                } else {
                    filterNum = this.filterNum
                }
                if (!numType) {
                    this.classCodeList = []
                }
                // 记得判断是否存在上一级目录
                if (filterNum == 1) {
                    this.dimensionList.forEach((dimensionItem) => {
                        if (dimensionItem.campusName === this.schoolName) {
                            if (this.gradeSet.indexOf(dimensionItem.gradeName) === -1) {
                                this.gradeSet.push(dimensionItem.gradeName)
                            }

                            if (this.subjectSet.indexOf(dimensionItem.subjectName) === -1) {
                                this.subjectSet.push(dimensionItem.subjectName)
                            }

                            if (this.classCodeList.indexOf(dimensionItem.classCode) === -1){
                                this.classCodeList.push(dimensionItem.classCode)
                            }
                        }
                    })
                }

                // 要判断是否存在该纬度，并且是否存在上一级纬度
                if (filterNum == 2) {
                    if (this.schoolName) {
                        this.dimensionList.forEach((dimensionItem) => {

                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.campusName === this.schoolName) {
                                if (this.gradeSet.indexOf(dimensionItem.gradeName) === -1) {
                                    this.gradeSet.push(dimensionItem.gradeName)
                                }
                            }

                            // 已选择的班号
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.gradeName === this.gradeName) {
                                if (this.subjectSet.indexOf(dimensionItem.subjectName) === -1) {
                                    this.subjectSet.push(dimensionItem.subjectName)
                                }

                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }

                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    } else {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (this.gradeSet.indexOf(dimensionItem.gradeName) === -1) {
                                this.gradeSet.push(dimensionItem.gradeName)
                            }

                            // 已选择的班号
                            if (dimensionItem.gradeName === this.gradeName) {
                                if (this.subjectSet.indexOf(dimensionItem.subjectName) === -1) {
                                    this.subjectSet.push(dimensionItem.subjectName)
                                }

                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }

                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    }
                }

                // 科目纬度
                // 学校，年级 / 学校 / 年级 / 都没有
                if (filterNum == 4) {
                    if (this.schoolName && this.gradeName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.gradeName === this.gradeName) {
                                if (this.subjectSet.indexOf(dimensionItem.subjectName) === -1) {
                                    this.subjectSet.push(dimensionItem.subjectName)
                                }
                            }

                            // 已选择的班号
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.gradeName === this.gradeName && dimensionItem.subjectName === this.subjectName) {

                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }

                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    } else if (this.schoolName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.campusName === this.schoolName) {
                                if (this.subjectSet.indexOf(dimensionItem.subjectName) === -1) {
                                    this.subjectSet.push(dimensionItem.subjectName)
                                }
                            }

                            // 已选择的班号
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.subjectName === this.subjectName) {

                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }

                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    } else if (this.gradeName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.gradeName === this.gradeName) {
                                if (this.subjectSet.indexOf(dimensionItem.subjectName) === -1) {
                                    this.subjectSet.push(dimensionItem.subjectName)
                                }
                            }

                            if (dimensionItem.gradeName === this.gradeName && dimensionItem.subjectName === this.subjectName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }

                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    } else {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (this.subjectSet.indexOf(dimensionItem.subjectName) === -1) {
                                this.subjectSet.push(dimensionItem.subjectName)
                            }

                            // 已选择的班号
                            if (dimensionItem.subjectName === this.subjectName) {

                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }

                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    }
                }

                if (filterNum == 3) {
                    // 学校，年级，科目 / 学校 年级 / 学校 科目 / 年级 科目 / 学校 / 年级 / 科目 / 都没有
                    if (this.schoolName && this.gradeName && this.subjectName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.gradeName === this.gradeName && dimensionItem.subjectName === this.subjectName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }
                            }

                            // 已选择的班号
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.gradeName === this.gradeName && dimensionItem.subjectName === this.subjectName && dimensionItem.classTime === this.timeName) {
                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    }else if (this.schoolName && this.gradeName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.gradeName === this.gradeName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }
                            }

                            // 已选择的班号
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.gradeName === this.gradeName && dimensionItem.classTime === this.timeName) {
                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    } else if (this.schoolName && this.subjectName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.campusName === this.schoolName  && dimensionItem.subjectName === this.subjectName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }
                            }
                            // 已选择的班号
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.subjectName === this.subjectName && dimensionItem.classTime === this.timeName) {
                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    }else if (this.gradeName && this.subjectName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.gradeName === this.gradeName && dimensionItem.subjectName === this.subjectName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }
                            }

                            // 已选择班号
                            if (dimensionItem.gradeName === this.gradeName && dimensionItem.subjectName === this.subjectName && dimensionItem.classTime === this.timeName) {
                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    }else if (this.schoolName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.campusName === this.schoolName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }
                            }

                            // 已选择的班号
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.classTime === this.timeName) {
                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    } else if (this.gradeName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.gradeName === this.gradeName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }
                            }

                            // 已选择的班号
                            if (dimensionItem.gradeName === this.gradeName && dimensionItem.classTime === this.timeName) {
                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    } else if (this.subjectName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.subjectName === this.subjectName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }
                            }

                            // 已选择的班号
                            if (dimensionItem.subjectName === this.subjectName && dimensionItem.classTime === this.timeName) {
                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    }else {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                this.classTimeSet.push(dimensionItem.classTime)
                            }

                            // 已选择的班号
                            if (dimensionItem.classTime === this.timeName) {
                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }
                            }
                        })
                    }
                }
                // 过滤课程
                if (num === 1) {
                    this.filterTypeList = this.campusSet
                } else if (num === 2) {
                    this.filterTypeList = this.gradeSet
                } else if (num === 3) {
                    this.filterTypeList = this.classTimeSet
                }else {
                    this.filterTypeList = this.subjectSet
                }

                if (!numType) {
                    this.getClassList()
                }
            },
            // 根据已选的纬度显示课程列表
            getClassList() {
                let contentList = []
                this.tempCourseClassList = [] // 这是选择纬度后要重新赋值，需置空
                this.courseClassList.forEach( (classItem) => {
                    if (this.classCodeList.indexOf(classItem.classCode) > -1) {
                        contentList.push(classItem)
                    }
                })
                this.tempCourseClassList = contentList
                this.total = contentList.length
                this.courseList = this.tempCourseClassList.slice(0, 20)
                if (this.tempCourseClassList && this.tempCourseClassList.length <= 2) {
                    this.isShowPullUpFooter = false
                } else {
                    this.isShowPullUpFooter = true
                }
                this.getStartPullUpState()
            },
            // 根据已选的纬度加载更多课程列表
            getMoreClassList () {
                let courseListIndex = this.courseList.length
                let moreClassList = this.tempCourseClassList.slice(courseListIndex, courseListIndex+10)
                this.courseList = this.courseList.concat(moreClassList)
            },
            // 获取班级列表
            getMarketClassList() {
                let data = {
                    activityId: this.activityId
                }
                getNewMarketClassList(data).then((res) => {
                    let courseData = res.data
                    //套餐列表订单列表
                    // 缓存信息
                    this.dimensionList = courseData.marketConfig
                    if (courseData.classList) {
                        courseData.classList.forEach((classItem) => {
                            // 购物车有数量时要自动匹配
                            let index = this.singleCartList && this.singleCartList.indexOf(classItem.classCode)
                            if (this.singleCartList && index > -1) {
                                // 用于套餐按钮的变化
                                classItem.isSelect = true
                            } else {
                                classItem.isSelect = false
                            }
                        })
                        this.courseClassList = courseData.classList
                        this.tempCourseClassList = courseData.classList // 首次加载需要给临时的存储一个值
                        this.courseList = this.courseClassList.slice(0, 20)
                        if (this.tempCourseClassList && this.tempCourseClassList.length <= 2) {
                            this.isShowPullUpFooter = false
                        }
                    }
                    this.total = courseData.classList.length

                    // 判断当前是否有参数
                    if (!this.schoolName && !this.gradeName && !this.subjectName && !this.timeName) {
                        this.getStartPullUpState()
                    } else {
                        this.getDimensionList()
                    }
                    Indicator.close()
                })
            },
            // 获取上拉加载的pullUpState状态
            getStartPullUpState () {
                if (this.courseList.length) {
                    if (this.total <= this.pageSize) {
                        // 修改子组件的pullUpState状态
                        this.pullUpState = 3
                    } else {
                        this.pullUpState = 1
                    }
                } else {
                    this.pullUpState = 0
                }
            },
            // 上拉加载
            onInfiniteLoad (done) {
                // 数组小于2
                if (!this.isShowPullUpFooter) {
                    return
                }

                if (this.pullUpState === 1) {
                    this.getPullUpMoreData()
                }
                done()
            },
            // 上拉一次加载更多的数据
            getPullUpMoreData () {
                // 调用课程列表
                if (this.total === this.courseList.length) {
                    this.pullUpState = 3
                } else {
                    this.pullUpState = 1
                    this.getMoreClassList()
                }
            },
            // 单个课程
            selectCourse (course) {
                if(course.registrationState === 6) {
                    return
                }
                this.courseList.forEach((classItem) => {
                    if (classItem.classCode === course.classCode) {
                        classItem.isSelect = !classItem.isSelect
                        if (classItem.isSelect) {
                            let index = this.singleCartList.indexOf(classItem.classCode)
                            if (index === -1) {
                                this.singleCartList.push(classItem.classCode)
                            }
                        } else {
                            let index = this.singleCartList.indexOf(classItem.classCode)
                            if (index > -1) {
                                this.singleCartList.splice(index, 1)
                            }
                        }
                    }
                })
                sessionStorage.setItem('singleCartList',JSON.stringify(this.singleCartList))
            },
            // 教学方式
            teachingMethod(methodCode) {
                return teachingMethodUtil(methodCode)
            },
            // 课时，课次
            getClassLessonTimes(lessonTimes, realMinutes) {
                return getClassLessonTimesUtil(lessonTimes, realMinutes)
            },
            // 住宿班
            getClassStay(modeCodes) {
                return getClassStayUtil(modeCodes)
            },
            // 名额紧张
            isFew(currentNum, maxNum, bmState) {
                return isFewUtil(currentNum, maxNum, bmState)
            },
            // 时间格式化
            formatDate(source, format) {
                return formatDateUtil(source, format)
            },
            // 记录渠道
            recordChannel(num) {
                let data = {
                    channelId: this.channelId,
                    u2at: this.U2AT,
                    wxNickname: this.wxNickName || '',
                    agn: this.agn || ''
                }
                recordChannel(data).then((res) => {
                    let reaData = res

                    // 记录访问页面
                    if (reaData.code == 1 && reaData.data && reaData.data.userid) {
                        sessionStorage.setItem('userId', reaData.data.userid)
                        gio('setUserId', reaData.data.userid)
                    }
                })
            },
            // 登陆授权验证
            checkWxLogin(num) {
                checkWxLogin().then((res) => {
                    let reaData = res
                    let url = this.getHttpUrl()

                    // 微信授权
                    if (reaData.code == 4002 && this.isWeChat) {
                        let wxLogin = configData.wxlogin
                        window.parent.location.href = wxLogin + '&returnUrl=' + encodeURIComponent(url)
                    }

                    if (reaData.code == 200 && reaData.data && reaData.data.wxNickName) {
                        this.wxNickName = reaData.data.wxNickName
                    }

                    // 测试数据 记录渠道
                    if (!num) {
                        this.U2AT = Cookies.get('U2AT')
                        let userId = sessionStorage.getItem('userId')
                        if (this.U2AT && !userId) {
                            this.recordChannel()
                        }
                    }

                    // 登录过期
                    if (num === 1) {
                        if (reaData.code == 4000) {
                            let urlLogin = configData.h5Login
                            window.parent.location.href = urlLogin + '&redirect_uri=' + encodeURIComponent(url)
                        } else {
                            let orderUrl = this.getOrderUrl()
                            window.parent.location.href = orderUrl
                        }
                    }
                })
            },
            payMoney() {
                if (!this.isBeginActivity) {
                    Toast({
                        message: '当前活动还未开始哦~',
                        duration: 2000,
                        className: 'noticeError'
                    })
                    return
                }

                if (this.singleCartList.length === 0) {
                    Toast({
                        message: '请选择需要报名的课程',
                        duration: 2000,
                        className: 'noticeError'
                    })
                    return
                }

                // 在app中去登陆
                if (xdfJs.xdfhybird.inApp) {
                    this.getAppToken()
                    return
                }

                if (this.U2AT) {
                    if (this.singleCartList && this.singleCartList.length === 0) {
                        return
                    }
                    // 已登陆 验证是否失效
                    this.checkWxLogin(1)
                } else {
                    // 未登录
                    let urlLogin = configData.h5Login
                    let url = this.getOrderUrl()
                    window.parent.location.href = urlLogin + '&redirect_uri=' + encodeURIComponent(url)
                }
            },
            // 获取app的token
            getAppToken() {
                xdfJs.xdfhybird.getUser( (data) => {
                    // 判断用户是否登陆
                    if (
                        data &&
                        data.user &&
                        !!data.user.userId &&
                        data.user.userId.length > 0
                    ) {
                        let token = data["user"]["accessToken"]
                        this.U2AT = token
                        Cookies.set('U2AT', token, { expires: 30, domain: 'xdf.cn' })
                        this.recordChannel()
                        // 跳转到支付
                        let url = this.getOrderUrl()
                        if (token) {
                            xdfJs.xdfhybird.openURL("xdfapp://student/web", {"url": url})
                        }
                    } else {
                        xdfJs.xdfhybird.openURL("xdfapp://student/login", {})
                    }
                })
            },
            // 微信分享
            getWxSdk() {
                let shareObj = {
                    urlLogo: this.activityInfo.shareUrl || '',// 分享图标
                    desc: this.activityInfo.shareDesc || ''
                }
                shareObj.title = this.activityInfo.shareTitle || this.activityInfo.title
                let params = this.getParams()
                shareObj.link = configData.originUrl + 'single/list?' + params
                wxSdk.getWxSdk(shareObj)
            },
            getParams() {
                let params = `activityId=${this.activityId}&channelId=${this.channelId}&schoolName=${this.schoolName}&gradeName=${this.gradeName}&timeName=${this.timeName}&subjectName=${this.subjectName}` +
                    `&selectSchoolId=${this.selectSchoolId}&selectGradeId=${this.selectGradeId}&selectTimeId=${this.selectTimeId}&selectSubjectId=${this.selectSubjectId}&selectNavString=${this.selectNavString}&filterNum=${this.filterNum}&agn=${this.agn}`
                return params
            },
            // 获取分享链接
            getHttpUrl() {
                let httpUrl = configData.originUrl + 'single/list?'
                let params = this.getParams()
                let url =  httpUrl + params
                return url
            },
            // ios内打电话
            callPhone() {
                if (!this.isIosApp) {
                    return
                }
                xdfJs.xdfhybird.loadPlugin("XDFHybirdCallPhonePlugin")
                xdfJs.xdfhybird.callPlugin("XDFHybirdCallPhonePlugin", "callPhone", {
                    number: Number(this.phone)
                })
            },
            getGan() {
                // 专题详情
                let data = {
                    activityId: this.activityId,
                    agn: this.agn
                }
                getGan(data).then((res) => {
                    let resData = res
                    if (resData.code == 1) {
                        this.agentName = resData.data.agentName
                    }
                })
            },
            // 提取订单URL
            getOrderUrl() {
                let classCodeList = this.singleCartList.join(",")
                let marketingSource = this.activityId + '_' + this.channelId
                if (this.agn) {
                    marketingSource = this.activityId + '_' + this.agn
                }
                let marketingSourceExt = this.activityInfo.uniActivityId
                let params = `appId=${configData.appId}&systemSource=${configData.systemSource}&schoolId=${this.schoolId}` +
                    `&classCodes=${classCodeList}&studentCode=&preOrderCode=&marketingSource=${marketingSource}&agentName=${this.agentName}&marketingSourceExt=${marketingSourceExt}`
                let orderUrl = `${configData.h5Bm}/page-h5bm/order?${params}`
                return orderUrl
            }
        }
    }
</script>

<style lang="less" scoped>
    .course_list_content {
        padding-bottom: 100px;
        .title_content {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            height: 98px;
            padding-top: 32px;
            padding-bottom: 24px;
            justify-content: space-around;
            background: #fff;
            z-index: 999;
            .title_name_content {
                .title_name {
                    font-size:30px;
                    color:rgba(51,51,51,1);
                    line-height:42px;
                    margin-right: 12px;
                    max-width: 120px;
                }
                .down_arrow_icon {
                    width: 16px;
                    height: 14px;
                }
                .title_name_color {
                    color:rgba(31,184,149,1);
                }
            }
        }
        .title_content_left {
            justify-content: flex-start;
            padding-left: 32px;
        }


        // 一级筛选框
        .filter_item_content_bg {
            position: fixed;
            z-index: 10000;
            left: 0;
            right: 0;
            top: 98px;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            .filter_item_content {
                width: 100%;
                position: absolute;
                z-index: 100;
                background: white;
                max-height: 80%;
                min-height: 20%;
                overflow: auto;
                .filter_item {
                    height: 102px;
                    width: 100%;
                    line-height: 102px;
                    .filter_item_line_name {
                        width: 80%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        height: 102px;
                        padding-left: 40px;
                        line-height: 102px;
                        font-size:30px;
                        color: #333;
                    }

                    .filter_item_line {
                        float: left;
                        height: 100%;
                        width: 8px;
                        background: linear-gradient(180deg, rgba(88, 213, 126, 1) 0%, rgba(40, 207, 185, 1) 100%);
                    }

                    .filter_item_line_name_color {
                        color: #1fb895;
                    }
                    .filter_item_line_none {
                        display: none;
                    }
                }
            }
        }
    }
    .course_list_content_top {
        padding-top: 98px;
    }
    .course_content_bottom {
        padding-bottom:170px;
    }
    .course_content_bottom_iphoneX {
        padding-bottom:168px;
    }
</style>
